export { default as SkeletonLoader } from './SkeletonLoader'
export { default as StyledSkeletonLoader } from './SkeletonLoader.Styled'
